import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween } from '../../../global/commonStyle';

export const ModalDiv = styled.div``;

// header section
export const HeaderSection = styled.div`
  padding: var(--space-12) var(--space-16);
  ${FlexBetween}
  gap: var(--space-10);
`;

export const HeaderTitle = styled.p`
  margin: var(--space-0);
  ${Typography.heading_md}
  color: var(--text-primary);
`;

export const HeaderRightSection = styled.div`
  ${AlignCenter}
  padding: var(--space-4);
  border-radius: var(--border-radius-12);
  background-color: var(--background-tertiary);
  .tabs {
    width: 86px;
  }
`;

// middle section

export const MiddleSection = styled.div`
  padding-inline: var(--space-16);
  ${AlignCenter}
  gap: var(--space-12);
  ${mobile_xl(css`
    flex-direction: column;
  `)}
`;

// bottom Section

export const BottomSection = styled.div`
  padding: var(--space-16);
  ${AlignCenter}
  justify-content: flex-end;
  gap: var(--space-12);
`;

export const Pricing = styled.p`
  margin: var(--space-0);
  ${Typography.body_md_medium}
  color: var(--text-primary);
`;
